import {
  useEnvironmentsContext,
  WbCard,
  WbButton,
  WbDockableGroup,
  WbDockablePanel,
  WbDockableResizeHandle,
  WbCardActions,
} from '@agilelab/plugin-wb-platform';
import { Entity } from '@backstage/catalog-model';
import { Box } from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import CachedIcon from '@material-ui/icons/Cached';
import { FC, useEffect, useState } from 'react';
import { PreviewDescriptorBox } from './PreviewDescriptorBox/PreviewDescriptorBox';
import { ReleaseCard } from './ReleaseCard';
import { TestCard } from './TestCard';
import { ReleaseSelect } from './TestCard/TestCard';
import { ControlPanelProvider, useControlPanel } from './useControlPanel';

const Descriptor: FC<{ loading: boolean }> = ({ loading }) => {
  const { selectedRelease, fetchPreviewDescriptorState } = useControlPanel();

  return (
    <PreviewDescriptorBox
      code={fetchPreviewDescriptorState.value}
      loading={loading}
      name={selectedRelease ? `${selectedRelease.metadata.version}` : 'HEAD'}
    />
  );
};

const ControlPanelPageComponent = () => {
  const { fetchPreviewDescriptorState, fetchPreviewDescriptor } =
    useControlPanel();
  const [testingCollapse, setTestingCollapse] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(fetchPreviewDescriptorState.loading);
  }, [fetchPreviewDescriptorState]);

  return (
    <Box>
      <WbDockableGroup direction="horizontal" style={{ height: '70vh' }}>
        <WbDockablePanel collapsible>
          <WbCard
            title="Descriptor"
            cardStyle={{ height: '100%' }}
            actions={
              <WbCardActions breakpoint="w_xs">
                <ReleaseSelect />

                <WbTooltip title="Refresh the descriptor by reading again all the values from the repositories. After you make a change on the repository files, click this button to reload and see the changes in the descriptor.">
                  <span>
                    <WbButton
                      onClick={() => {
                        setLoading(true);
                        fetchPreviewDescriptor().finally(() => {
                          setLoading(false);
                        });
                      }}
                      label="Refresh"
                      icon={<CachedIcon />}
                      disabled={loading}
                      fullWidthUnderBreakpoint="w_xs"
                    />
                  </span>
                </WbTooltip>
              </WbCardActions>
            }
          >
            <Box display="flex" flexDirection="column" height="100%">
              <Descriptor loading={loading} />
            </Box>
          </WbCard>
        </WbDockablePanel>

        <WbDockableResizeHandle direction="horizontal" />
        <WbDockablePanel
          tab={{
            isCollapsed: testingCollapse,
            setCollapsed: isCollapsed => setTestingCollapse(isCollapsed),
            title: 'Test',
            direction: 'horizontal',
          }}
          defaultSize={40}
          collapsible
        >
          <TestCard
            onCollapse={() => {
              setTestingCollapse(true);
            }}
          />
        </WbDockablePanel>
      </WbDockableGroup>

      <Box mt={2} height="70vh">
        <ReleaseCard />
      </Box>
    </Box>
  );
};

export const ControlPanelPage = (props: {
  entity: Entity;
  setVersion: (input: string) => void;
}) => {
  const { environment } = useEnvironmentsContext();

  return environment.name ? (
    <ControlPanelProvider entity={props.entity} setVersion={props.setVersion}>
      <ControlPanelPageComponent />
    </ControlPanelProvider>
  ) : (
    <></>
  );
};
